import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from "./Responses";
import { ITherapyAddModel } from "../models/ITherapyAddModel";


export class TherapyService extends AbstractApiService {
    constructor() {
        super();
    }

    public SearchTherapies(searchValue: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/therapy/searchtherapies?searchValue=' + encodeURI(searchValue), onSuccess, onError);
    }

    public MyClinicTherapies(clinicId: number, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/therapy/myclinictherapies?clinicId=' + encodeURI(clinicId.toString()), onSuccess, onError);
    }
    
    public MyClinicTherapiesForEdit(clinicId: number, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/therapy/myclinictherapiesforedit?clinicId=' + encodeURI(clinicId.toString()), onSuccess, onError);
    }

    public AddMyClinicTherapy(model: ITherapyAddModel, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/therapy/addmyclinictherapy', model, onSuccess, onError);
    }

    public AddMyTherapy(model: ITherapyAddModel, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/therapy/addmytherapy', model, onSuccess, onError);
    }

    public RemoveMyClinicTherapy(therapyId: number, clinicId: number, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/therapy/removemyclinictherapy', {
            therapyId,
            clinicId
        }, onSuccess, onError);
    }

    public RemoveMyTherapy(therapyId: number, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/therapy/removemytherapy', therapyId, onSuccess, onError);
    }

    public GetTherapiesForAcceptance(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/therapy/accepttherapylist', onSuccess, onError);
    }

    public AcceptTherapies(therapiesToAccept: number[], onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/therapy/accepttherapies', therapiesToAccept, onSuccess, onError);
    }

    public DiscardTherapy(therapyId: number, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/therapy/discardtherapy', therapyId, onSuccess, onError);
    }

    public GetAllMyClinicTherapies(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/therapy/getallmyclinictherapies', onSuccess, onError);
    }

    public GetAllPhysiotherapistsClinicTerapies(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/therapy/getallphysiotherapistsclinictherapies?physiotherapistId=' + physiotherapistId.toString(),
            onSuccess,
            onError);
    }

    public GetAllMyTherapies(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/therapy/getallmytherapies', onSuccess, onError);
    }

    public GetAllPhysiotherapistsTerapies(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/therapy/getallphysiotherapiststherapies?physiotherapistId=' + physiotherapistId,
            onSuccess,
            onError);
    }

    public GetPhysiotherapistClinicTherapies(
        physiotherapistId: string,
        clinicId: number,
        onSuccess: OnRequestSuccess,
        onError: OnRequestError
    ) {
        this.Get('api/therapy/getphysiotherapistclinictherapies?physiotherapistId='
            + physiotherapistId
            + '&clinicId='
            + clinicId.toString(),
            onSuccess,
            onError);
    }
    
}


// WEBPACK FOOTER //
// ./src/services/TherapyService.tsx